<script setup lang="ts">
/**
 * Standard slideover footer with Cancel + Submit buttons.
 * Encodes the button layout, gap, variants, and sizing decisions.
 */

defineProps<{
  /** Label for the submit button (e.g. "Save", "Create Tag") */
  submitLabel: string
  /** Form ID to connect the submit button to a <form> element */
  formId: string
  /** Loading state for the submit button */
  loading?: boolean
}>()

const emit = defineEmits<{
  cancel: []
}>()
</script>

<template>
  <div class="flex gap-4">
    <UButton
      label="Cancel"
      color="neutral"
      variant="outline"
      class="flex-1"
      @click="emit('cancel')"
    />
    <UButton
      type="submit"
      :form="formId"
      :label="submitLabel"
      color="primary"
      class="flex-1"
      :loading="loading"
    />
  </div>
</template>
